import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F13342",
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.67",
      d: "M13.525 3.525a2.086 2.086 0 0 1 2.95 2.95L12.949 10l3.526 3.525.027.03.086.094.028.034a2.086 2.086 0 0 1-2.933 2.933l-.034-.028-.094-.086-.03-.027L10 12.949l-3.525 3.526a2.086 2.086 0 0 1-2.95-2.95L7.051 10 3.525 6.475a2.086 2.086 0 0 1 2.95-2.95L10 7.051z",
      style: {"fill":"var(--global-red-primary)"}
    }, null, -1)
  ])))
}
export default { render: render }